import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";

type AnonymousBackInStockContextValue = {
  anonymousBackInStockProducts: number[];
  saveVariant: (variantId: number) => void;
};

const AnonymousBackInStockContext =
  createContext<AnonymousBackInStockContextValue | null>(null);

type AnonymousBackInStockProviderProps = {
  children: ReactNode;
};

export const AnonymousBackInStockProvider = ({
  children,
}: AnonymousBackInStockProviderProps) => {
  const [anonymousBackInStockProducts, setAnonymousBackInStockProducts] =
    useState<number[]>([]);

  const handleVariantUpdate = useCallback((selectedVariantId: number) => {
    setAnonymousBackInStockProducts((prevAnonymousBackInStockProducts) => {
      if (
        !selectedVariantId ||
        prevAnonymousBackInStockProducts.includes(selectedVariantId)
      ) {
        return prevAnonymousBackInStockProducts;
      }
      return [...prevAnonymousBackInStockProducts, selectedVariantId];
    });
  }, []);

  return (
    <AnonymousBackInStockContext.Provider
      value={{
        anonymousBackInStockProducts,
        saveVariant: handleVariantUpdate,
      }}
    >
      {children}
    </AnonymousBackInStockContext.Provider>
  );
};

export const useAnonymousBackInStock =
  (): AnonymousBackInStockContextValue | null =>
    useContext(AnonymousBackInStockContext);
